import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NavLink from './NavLink.jsx';
import AppSearch from './AppSearch/AppSearch.jsx';
import { GECKO_UTILS, GeckoBtn } from 'ui';
import { connect } from 'react-redux';
import { renderError } from 'services/gecko-error';
import { setLoggedInUser } from 'actions/appState';
import './NavBar.scss';
import UserAvailability from '../utilities/userAvailability';
import AiInsightsModal from '../routes/settings/AiInsights/AiInsightsModal.jsx';
import { GeckoModalService } from 'ui';
export class NavBar extends Component {
  hasChildren() {
    return (
      (this.props.navLinks && this.props.navLinks.length) ||
      this.props.children ||
      this.props.items
    );
  }

  getNavLinks() {
    return !this.props.navLinks
      ? ''
      : this.props.navLinks
          .filter((link) => !link.hidden)
          .map((link) => (
            <NavLink
              key={link.linkText}
              exact={link.exact}
              activeClassName={link.activeClassName}
              className={link.className}
              to={link.to}
            >
              {link.linkText}
            </NavLink>
          ));
  }

  getRightBtns() {
    return !this.props.items
      ? ''
      : this.props.items.map((item) => (
          <span
            style={{
              marginLeft: 10,
              display: item.inactive ? 'inline-block' : 'none',
            }}
          >
            <GeckoBtn
              inactive={item.inactive}
              icon={item.icon}
              type={item.type}
              name={item.name}
              handler={item.handler}
            />
          </span>
        ));
  }

  renderLeftCol() {
    if (this.hasChildren()) {
      return (
        <div className="filter-btns">
          <div>{this.props.children}</div>
          <div>
            {this.getNavLinks()}
            {this.props.showAIInsights && (
              <span onClick={this.renderAiInsightsModal}>AI Settings</span>
            )}
          </div>
        </div>
      );
    }
    return null;
  }

  renderAiInsightsModal = () => {
    new GeckoModalService().open(() => {
      return <AiInsightsModal />;
    });
  };

  renderRightCol() {
    if (this.props.noSearch) {
      return (
        <div className="right-btns hidden-md d-flex align-items-center">
          <div className="text-right">{this.getRightBtns()}</div>
        </div>
      );
    }
  }

  renderSearch() {
    const classes = ['d-none d-xl-block'];
    if (!this.hasChildren()) {
      classes.push('hidden-md');
    } else {
      classes.push('hidden-md');
    }
    if (!this.props.noSearch) {
      return (
        <div className={GECKO_UTILS.classNames(classes)}>
          <div
            style={{ maxWidth: 350, position: 'absolute', right: 8 }}
            className="col text-right"
          ></div>
        </div>
      );
    }
    return null;
  }

  renderUnavailableBanner() {
    if (!this.props.connected) {
      return <UserDisconnectedBanner />;
    }

    if (!this.props.web_available && !this.props.mobile_available) {
      return (
        <div className="unavailable-banner">
          <span className="unavailable-message">
            <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
            <span>{`  Your status is currently set to 'Unavailable'. Click `}</span>
            <span
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() =>
                this.updateUserAvailabilityWeb(this.props.loggedInUser)
              }
            >
              {'here'}
            </span>
            <span>{' to make yourself available.'}</span>
          </span>
        </div>
      );
    }
    if (!this.props.web_available && this.props.mobile_available) {
      return (
        <div className="mobile-only-available-banner">
          <span className="unavailable-message">
            <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
            <span>{`  You're currently only 'Available' on the mobile app. Click `}</span>
            <span
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() =>
                this.updateUserAvailabilityWeb(this.props.loggedInUser)
              }
            >
              {'here'}
            </span>
            <span>{` to make yourself 'Available' or `}</span>
            <span
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() =>
                this.updateUserAvailabilityMobile(this.props.loggedInUser)
              }
            >
              {`make me 'Unavailable' on the app.`}
            </span>
          </span>
        </div>
      );
    }
    return null;
  }

  getClassName() {
    return (
      (this.props.loggedInUser.web_available
        ? 'AppSubNav sub-nav'
        : 'AppSubNav sub-nav unavailable') +
      ` ${this.props.connected ? '' : 'disconnected'}`
    );
  }

  updateUserAvailabilityWeb(user) {
    UserAvailability.updateUserAvailability(user).catch(renderError);
    this.props.setLoggedInUser(user);
  }

  updateUserAvailabilityMobile(user) {
    UserAvailability.updateUserMobileAvailability(user).catch(renderError);
    this.props.setLoggedInUser(user);
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderUnavailableBanner()}
        <div className="nav-links">
          {this.renderLeftCol()}
          {this.renderRightCol()}
        </div>
        {this.renderSearch()}
      </div>
    );
  }
}

NavBar.defaultProps = {
  navLinks: null,
};

NavBar.propTypes = {
  navLinks: PropTypes.array,
};

const UserDisconnectedBanner = () => (
  <div
    className="unavailable-banner"
    style={{ cursor: 'pointer' }}
    onClick={() => window.location.reload(true)}
  >
    <span className="unavailable-message">
      <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
      <span style={{ marginLeft: '5px' }}>
        Disconnected from GeckoChat. <u>Try reloading</u>.
      </span>
    </span>
  </div>
);

const mapStateToProps = (state) => {
  return {
    loggedInUser: state.appState.loggedInUser,
    web_available: state.appState.loggedInUser.web_available,
    mobile_available: state.appState.loggedInUser.mobile_available,
    connected: state.appState.connected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoggedInUser: (user) => dispatch(setLoggedInUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
